import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,   
    });
  }, []);

  
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.refreshHard();   
  }, [pathname]);

  return null;
};

export default ScrollToTop;